import React, {useState, useEffect, useCallback} from 'react';
import PhoneNumber from '../PhoneNumber';
import {LoadingIndicator} from '../../lib/iprs-react-library/src/index';

const ReferralSearch = ({postCode, setPostCode, api, setSearchResult, brandingInfo}) => {
    const [error, setError] = useState('');
    const [noResult, setNoResult] = useState(false);
    const [searchStatus, setSearchStatus] = useState(false);

    const searchRequest = (e, postCodeSearch) => {
        setSearchResult(null)
        setError('')
        setSearchStatus(true)

        let pc = postCode;

        if(postCodeSearch !== undefined && postCodeSearch !== null) {
            pc = postCodeSearch;
        }

        const params = {
            "Postcode": pc,
            "Flag": "Self Referral"
        }

        api.transact("PWPracticeSearch", params)
            .then(r => {
                console.log(r);
                if(r.apiResult.FacilityList.length < 1){
                    setNoResult(true)
                } else {
                    console.log(r.apiResult);                    
                    setSearchResult(r.apiResult);
                    setNoResult(false);
                }
                setSearchStatus(false);
            })
            .catch(error => {
                console.log(error);
                setError(error.message);
                setSearchStatus(false);
            });
    }

    useEffect(()=>{
        if(error !== ''){
            return null
        }

        const queryParams = new URLSearchParams(window.location.search);
        const postcodeSearch = queryParams.get("postcode");
        if(postcodeSearch !== undefined && postcodeSearch !== null && postcodeSearch !== '') {
            setPostCode(postcodeSearch);            
            searchRequest(null, postcodeSearch);
        }

    },[])

    return (
        <>
            <div className="typography">
                    {!noResult 
                        ?   <h1>Search for a clinic near you!</h1>
                        :   <>
                                <h1 style={{fontSize: '3.2rem'}}>We’re sorry, there are no clinics near you</h1>
                                <p style={{
                                    fontSize: '1.6rem', 
                                    margin: '0 auto',
                                    marginBottom: '4em',
                                    maxWidth: '664px'
                                }}>We are sorry that we have not been able to display a clinic local to you. 
                                   You have the option to search using an alternative postcode below or IPRS Health has 
                                   several support clinics that may be able to assist you but are not shown within the 
                                   search, to find out more please contact <PhoneNumber brandingInfo={brandingInfo}/> to talk to one of our team.</p>  
                                {/* {error ? <p>API responded with error: {error}</p> : <></>}               */}
                            </>
                    }

                <div className="AvivaPortalReferralSearchDiv">
                    <div 
                        style={{
                            display: 'flex'
                        }}
                        className="AvivaPortalReferralSearchLabelAndInputDiv"
                    >
                        <label 
                            htmlFor="postcode"
                        >
                            Your Postcode
                        </label>
                        <input 
                            id="postcode" 
                            className="form__input" 
                            type="text"
                            value={postCode} 
                            onInput={(e)=>setPostCode(e.target.value)}
                        />
                    </div>
                    <button 
                        href="#" 
                        className="green-button"                        
                        onClick={searchRequest}
                        disabled={searchStatus}
                    >
                        {
                            searchStatus ? 
                                <LoadingIndicator 
                                    size={20}
                                    loading={searchStatus} 
                                    color={"#FFFFFF"}
                                /> :
                                "Search"
                        }
                        
                    </button>
                </div>
                <div>
                    {/* <p>
                        {error}
                    </p> */}
                    {error ? <p> {error}</p> : <></>}
                </div>
            </div>
        </>
    )
}

export default ReferralSearch